import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { Industry } from '../../../extViewmodels';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export function useIndustryCategoryMutation({
	onError,
	onSuccess,
}: {
	onError?: (err: Api.IOperationResultNoValue) => void;
	onSuccess?: (value: Api.ITemplateCategory) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		// @ts-ignore
		mutationFn: ({ name, industry }: { name: string; industry: Industry }) => {
			return userSession.webServiceHelper.callAsync(
				`admin/template/${encodeURIComponent(industry)}/cardCategories`,
				'POST',
				{
					name,
					templates: [],
					total: 0,
					type: Api.TemplateCategoryType.Default,
				}
			);
		},
		onError,
		onSuccess,
	});
}
